import React, { useEffect, useState } from "react";
import "./TimeLine.css";

import rajanikanth from "./images/Rajanikanth.png";
import samba from "./images/Sambasiva.png";
import satish from "./images/Satish.jpeg";
import Kalpana from "./images/Kalpana.png";
import Rajendra from "./images/Rajendra.png";

const TimeLine = () => {
  const [activeItem, setActiveItem] = useState(0);

  

  useEffect(() => {
    const handleScroll = () => {
      const timelineItems = document.querySelectorAll(".timeline-item");
      const scrollPosition = window.scrollY;

      let activeIndex = -1;

      timelineItems.forEach((item, index) => {
        const itemTop = item.getBoundingClientRect().top + window.scrollY;
        const itemHeight = item.offsetHeight;

        if (
          scrollPosition >= itemTop - 35 &&
          scrollPosition < itemTop + itemHeight - 35
        ) {
          activeIndex = index;
        }
      });
      console.log("Active Index:", activeIndex);
      if (activeIndex !== -1 && activeIndex !== activeItem) {
        setActiveItem(activeIndex);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeItem]);

    return (
    <>
      <div className="timeline-container" id="timeline-1">
        <div className="timeline-header">
          <h2 className="timeline-header__title">MEET OUR TEAM</h2>
          <h3 className="timeline-header__subtitle">NEW AND CREATIVE</h3>
        </div>
        <div className="timeline">
          {timelineData.map((item, index) => (
            <div
              key={index}
              data-text="MEET OUR TEAM"
              className={`timeline-item ${
                index === activeItem ? "timeline-item--active" : ""
              }`}
            >
              <div className="timeline__content">
                <img
                  className="timeline__img"
                  src={item.img}
                  alt={item.title}
                />
                 {/* <div class="star"> */}
                <h2 className="timeline__content-title">{item.title}</h2>
                 {/* </div> */}
                 {/* <div class="star"></div> */}
                <h3>{item.role}</h3>
                <p className="timeline__content-desc">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const timelineData = [
  {
    img: rajanikanth,
    title: "Rajanikanth D.",
    role: "Founder & Director",
    description:
      "Bringing over 16 years of industry experience in functional verification, with expertise across block, subsystem, and SoC levels, he has built a strong foundation working with both product and services organizations. His experience spans complex semiconductor verification challenges, driving quality and reliability in silicon development.",
  },
  {
    img: Kalpana,
    title: "Kalpana D",
    role: "Co Founder",
    description:
      "Kalpana Madam, our Co-Founder, has played a remarkable leadership role in shaping the vision and growth of our company. With her strong guidance, dedication, and strategic thinking, she has transformed ideas into reality and built a strong foundation for the organization. Her leadership inspires the entire team to work with commitment, innovation, and integrity toward achieving greater success.",
  },
  {
    img: samba,
    title: "Sambasiva Rao",
    role: "Chief Executing Officer",
    description:
      "A highly accomplished leader with over three decades of experience in the semiconductor industry, his expertise spans Physical Design and Product Engineering, with extensive experience across both product and services organizations. After spending nearly 30 years with leading product companies such as BEL and Cypress Semiconductor, he went on to head the Malaysia operations at UST Global, building a 420+ engineer team from scratch within four years.In 2018, he joined Eximius Design to establish their Malaysia operations, growing a 250-engineer team focused on Physical Design, DFT, and Product Engineering. He also served as Executive Vice President at Appex Semiconductor for two years, contributing to strategic and operational growth.",
  },
  {
    img: satish,
    title: "Satish V.",
    role: "Chief Technical Officer",
    description:
      "Technology and business visionary professional with a 24+ years of dynamic career and an unmatched track record in Aerospace Engineering, Embedded Systems, and Project Management. Specializing in strategic planning, program management, and leading cross-functional teams. Aim to drive innovation, deliver high-quality solutions, and contribute to the advancement of Embedded technology",
  },
  {
    img: Rajendra,
    title: "P Rajendra Prasad",
    role: "Chief Operating officer",
    description:
      "Pitta Rajendra Prasad brings 18+ years of experience in the software industry, with expertise in Microsoft Power BI, Microsoft SQL Server, and BizTalk Server. He has strong experience in delivery management, operations, and enterprise technology solutions, along with deep knowledge of Supply Chain domains. At TechSoc, he leads operational excellence and drives efficient execution of business strategies.",
  },

 ];

export default TimeLine;
